import React from 'react';
import merge from 'lodash/merge';

import Button from 'components/layout/Button';
import Modal from 'components/layout/modal';
import UserAccess from './userAccess.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

import events from 'lib/events';
import session from 'services/sessionService';
import dealerApi from 'api/dealer';


const USER_TYPES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  TESTER: 'tester',
};


class UserAccessManagerModal extends React.PureComponent {
  static displayName = 'UserAccessManagerModal';

  state = {
    isPosDashboardAvailableTester: false,
    isPurchaseHistoryAvailableTester: false,
    visible: false,
    usersType: {
      [USER_TYPES.ADMIN]: {
        purchaseHistory: true,
        detailedReporting: true,
        dashboard: true,
      },
      [USER_TYPES.MANAGER]: {
        purchaseHistory: false,
        detailedReporting: false,
        dashboard: false,
      },
      [USER_TYPES.TESTER]: {
        purchaseHistory: false,
        detailedReporting: false,
        dashboard: false,
      },
    },
  };

  componentWillMount() {
    this.listener = events.subscribe('user-access-manager', () => {
      this.setState({
        visible: true,
      });
    });

  }

  componentDidMount() {
    this.update();
  }

  componentWillUnmount() {
    if (this.listener) {
      this.listener.remove();
    }
  }

  update = () => {
    dealerApi.getDealer(session.getUser().dealerId)
      .then((results) => {
        const actualPermissions = {
          [USER_TYPES.MANAGER]: {
            purchaseHistory: results.managerPurchaseHistory,
            detailedReporting: results.managerDetailedReporting,
            dashboard: results.managerDashboard,
          },
          [USER_TYPES.TESTER]: {
            purchaseHistory: results.testerPurchaseHistory,
            detailedReporting: results.testerDetailedReporting,
            dashboard: results.testerDashboard,
          },
        };

        this.setState({usersType: merge({}, this.state.usersType, actualPermissions)});
      });
  };

  save = () => {
    const usersType = {
      'managerPurchaseHistory': this.state.usersType.manager.purchaseHistory,
      'managerDetailedReporting': this.state.usersType.manager.detailedReporting,
      'managerDashboard': this.state.usersType.manager.dashboard,
      'testerPurchaseHistory': this.state.usersType.tester.purchaseHistory,
      'testerDetailedReporting': this.state.usersType.tester.detailedReporting,
      'testerDashboard': this.state.usersType.tester.dashboard,
    };

    dealerApi.saveDealerUserAccess(session.getUser().dealerId, usersType);
    this.close();
  };

  close = () => {
    this.setState({
      visible: false,
    });
  };

  cancel = () => {
    this.close();
    this.update();
  };

  onPermissionChange = (userType, permission) => {
    const usersType = Object.assign({}, this.state.usersType);

    usersType[userType][permission.key] = permission.value;
    this.setState({usersType: usersType});
  };

  render() {
    if (!this.state.visible) {
      return null;
    }

    let {formatMessage} = this.props.intl;

    return (
      <Modal onClose={this.close} width={700}>
        <div className="user-access-manager">
          <div className="row">
            <h1><FormattedMessage id="integrations.manage.user.access" /></h1>
            <hr/>
          </div>
          <div className="row">
            <FormattedMessage id="integrations.mua.description.one" /> <i className="bl bl-help help-icon"/> <FormattedMessage id="integrations.mua.description.two" />.
          </div>
          <div className="row">
            <UserAccess title={formatMessage({id: 'integrations.admin.level.users'})} isAdmin={true}
                        userType={this.state.usersType[USER_TYPES.ADMIN]} />    <UserAccess title={formatMessage({id: 'integrations.manager.level.users'})} isAdmin={false} userType={this.state.usersType[USER_TYPES.MANAGER]} onPermissionChange={this.onPermissionChange.bind(null, 'manager')}/>
            <UserAccess

                                hideSecondPermission={true}
                                isAdmin={false}
                                onPermissionChange={this.onPermissionChange.bind(null, 'tester')}
                                title={formatMessage({id: 'integrations.water.test.station'})}
                                userType={this.state.usersType[USER_TYPES.TESTER]}
                            />
          </div>
        </div>
        <div className="integration-modal-buttons">
          <Button default onClick={this.cancel}><FormattedMessage id="general.cancel" /></Button>
          <Button primary onClick={this.save}><FormattedMessage id="general.save" /></Button>
        </div>
      </Modal>
    );
  }
    }

export default injectIntl(UserAccessManagerModal);
